import React from 'react';
import { useSelector } from 'react-redux';
import { getRTL } from '@yme/selectors/index';
import { PopupOrderItem } from './PopupOrderItem';
import { OrderItemsListStyled, OrderItemsWrapperStyled } from './styled';
export const PopupOrderSummary = ({ setIsLoading, handleRemoveProduct, rootLanguage, cartEntries, }) => {
    const isRightToLeft = useSelector(getRTL);
    const isScrollNeeded = cartEntries.length > 3;
    return (React.createElement(OrderItemsWrapperStyled, { isScrollNeeded: isScrollNeeded, isRightToLeft: isRightToLeft },
        React.createElement(OrderItemsListStyled, null, cartEntries.map((item) => (React.createElement(PopupOrderItem, { item: item, key: item.lineItemId, isRightToLeft: isRightToLeft, rootLanguage: rootLanguage, productName: item.name, productType: item.productType, setIsLoading: setIsLoading, handleRemoveProduct: handleRemoveProduct }))))));
};
